import { useCallback, useEffect, useState } from "react";
import { getDataAdapter } from "@/data";
export function useTimeEntries(filter, deps = []) {
    const adapter = getDataAdapter();
    const [entries, setEntries] = useState([]);
    const [loading, setLoading] = useState(true);
    const reload = useCallback(async () => {
        setLoading(true);
        const list = await adapter.listTimeEntries(filter);
        setEntries(list);
        setLoading(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [adapter, JSON.stringify(filter)]);
    useEffect(() => {
        void reload();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reload, ...deps]);
    return { entries, loading, reload };
}
